import React from 'react'
import { Resizable } from 'react-resizable'
import type { ResizeCallbackData } from 'react-resizable'
import cx from 'classnames'
import styles from './ResizableTitle.module.scss'

interface TitlePropsType {
  width: number
  onResize: (e: React.SyntheticEvent<Element>, data: ResizeCallbackData) => void
}

const ResizableTitle: React.FC<Readonly<React.HTMLAttributes<any> & TitlePropsType>> = props => {
  const { onResize, width, ...restProps } = props

  if (!width) {
    return <th {...restProps} className={cx(styles.reactResizable, restProps.className)} />
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={<span className={styles.reactResizableHandle} onClick={e => e.stopPropagation()} />}
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} className={cx(styles.reactResizable, restProps.className)} />
    </Resizable>
  )
}

export default ResizableTitle
